<template>
  <fragment>
    <div class="divider is-form-divider is-blue" style="margin-top: 30px;"></div>
    <div class="columns is-multiline">
    <div  v-for="(item) in items" v-bind:key="item.value">
      <div class="column">
        <div class="field">
          <b-radio :name="`codetype`" required :key="item.value" :native-value="item.value" @input="onInput" v-model="newModel">
            <b>{{ item.title }}</b><br>
          </b-radio>
        </div>
      </div>
    </div>
    </div>

  </fragment>
</template>

<script>
export default {
  name: 'WsRequestExamCodeTypeForm',
  $_veeValidate: {
    name () {
      return this.name
    },
    value () {
      return this.value
    }
  },
  props: {
    items: Array,
    value: String,
    name: String
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler (model) {
        this.newModel = model
        // this.newModel = Array.isArray(model) ? model : []
      }
    }
  },
  data: function () {
    return {
      newModel: ''
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>
